import React from 'react';
import { formatNumberWithCommas } from '../../../../../tools/NumberTool';

const SettlementTable = ({ tableData }) => {
  return (
    <table>
      <thead>
        <tr>
          <th style={{ width: '70px' }}>정산 일자</th>
          <th>정산 금액</th>
          <th>판매 금액</th>
          <th>
            공제합계 <br />
            (①+②+③)
          </th>
          <th>배송비</th>
          <th>유보금(+)</th>
          <th>유보금(-)</th>
          <th>①마켓수수료</th>
          <th>②광고수수료</th>
          <th>③기타공제</th>
        </tr>
      </thead>
      <tbody>
        {!tableData || tableData.length === 0 ? (
          <tr>
            <td colSpan={10} className="noList">
              <p>데이터가 없습니다.</p>
            </td>
          </tr>
        ) : (
          tableData?.map((row, index) => (
            <tr key={index}>
              <td style={{ textAlign: 'center' }}>{row.baseMonth}</td>
              <td>{formatNumberWithCommas(row.settlementAmt)}</td>
              <td>{formatNumberWithCommas(row.saleAmt)}</td>
              <td>{formatNumberWithCommas(row.deductionSummation)}</td>
              <td>{formatNumberWithCommas(row.deliveryFee)}</td>
              <td>{formatNumberWithCommas(row.plusReservationAmt)}</td>
              <td>{formatNumberWithCommas(row.minusReservationAmt)}</td>
              <td>{formatNumberWithCommas(row.marketFee)}</td>
              <td>{formatNumberWithCommas(row.advertisementFee)}</td>
              <td>{formatNumberWithCommas(row.etcDeduction)}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};

export default SettlementTable;
